import React, {Component} from 'react';
import {Card, CardBody, CardHeader, Input} from 'reactstrap';
import 'ladda/dist/ladda-themeless.min.css';
import {getData} from '../../api/doLogin.js';
import {Calendar as BigCalendar, momentLocalizer} from "react-big-calendar";
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {displayMilHoursMinutesFromTime, forceSingleTimeZone, formatTimeFromEpoch} from "../../util/datehelpers";
import {LoadingDialog} from "../../components/Shared/LoadingDialog";
import {EventClient} from "../../util/eventClient";
import {trimJoin} from "../../util/stringhelpers";
import {runFunctionIf} from "../../util/dataHelpers";
import {getAARStatus} from "../../constants/AARConstants";
import "./views/Calendar.css"
//https://github.com/jquense/react-big-calendar/tree/af82bd75466c1b3ca699cb2427a342bbbbeef0a3
//http://intljusticemission.github.io/react-big-calendar/examples/index.html#dnd

const brandPrimary = '#20a8d8';
const brandSuccess = '#4dbd74';
const brandInfo = '#63c2de';
const brandWarning = '#f8cb00';
const brandDanger = '#f86c6b';

let localizer = momentLocalizer(moment)

// const DraggableBigCalendar = withDragAndDrop(BigCalendar);

export class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataLoaded: false,
      preview: null,
      showPicker: false,
      tempData: {},
      cal_id: 0,
      events: [],
      calendarList: [],
      chosenCalendar: props['match']['params']['cal_id'] || props.loginID,
      lead: null,
      loading: true,
      dateRange: {
        start: 0,
        end: 0
      },
      fetchRange: {
        start: (Math.round((new Date()).getTime() / 1000)) - (60 * 24 * 3600),
        end: (Math.round((new Date()).getTime() / 1000)) + (60 * 24 * 3600)
      },
      currentDate: new Date(),
      currentView: 'month',
      showAddCalEntry: false,
      editID: null,
      addSelection: {}
    };
    this.getLeadData.bind(this);
    this.updateData.bind(this);
  }

  componentDidMount() {
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [2]}}]) ? 2 : this.accessLevel;
    // this.accessLevel = checkPerms(this.props.perms, [{admin: {cameras: [3]}}]) ? 3 : this.accessLevel;
    this.computeDisplayedDateRange();
    let self = this;
    this.getLeadData(() => {
      self.updateData(self.state.fetchRange);
    });
    EventClient.on("CALENDAR_REFRESH", () => self.updateData(), "Calendar")
  }

  componentWillUnmount() {
    EventClient.off("CALENDAR_REFRESH", () => this.updateData(), "Calendar")
  }

//prevState.chosenCalendar !== this.state.chosenCalendar ||
  componentDidUpdate(prevProps, prevState) {
    if (prevProps['match']['params']['cal_id'] !== this.props['match']['params']['cal_id'] || prevProps['match']['params']['lead_id'] !== this.props['match']['params']['lead_id']) {
      let self = this;
      runFunctionIf((cb) => {
        self.setState({chosenCalendar: this.props['match']['params']['cal_id']}, cb)
      }, prevProps['match']['params']['cal_id'] !== this.props['match']['params']['cal_id'], () => {
        runFunctionIf((cb) => {
          this.getLeadData(cb)
        }, prevProps['match']['params']['lead_id'] !== this.props['match']['params']['lead_id'], () => {
          self.updateData(self.state.fetchRange);
        })
      })
      return false;
    }
  }

  getLeadData(cb) {
    let self = this;
    let lmsId = this.props['match']['params']['lead_id'];
    if (lmsId && Number(lmsId) > 0) {
      getData(`lms/${lmsId || 0}`, {})
        .then((data) => {
          if (data.status === "Success") {
            console.log(data.data);
            let responseStateData = {
              lead: data.data.lead,
            };
            self.setState(responseStateData, () => {
              cb()
            });
          }
        }).catch((error) => {
        console.log(error);
        cb()
      });
    } else {
      self.setState({lead: null}, () => {
        cb();
      })
    }
  }

  setCurrentDate(date) {
    this.setState({currentDate: date}, () => {
      this.computeDisplayedDateRange();
    });
  }

  setCurrentView(view) {
    this.setState({currentView: view}, () => {
      this.computeDisplayedDateRange();
    });
  }

  computeDisplayedDateRange() {
    const {currentDate, currentView} = this.state;
    let start = moment(currentDate).startOf(currentView);
    let end = moment(currentDate).endOf(currentView);
    if (currentView === 'month') {
      start = start.startOf('week');
      end = end.endOf('week');
    }
    this.setState({dateRange: {start: start, end: end}}, () => {
      if (currentView !== 'month') {
        start = start.startOf('week');
        end = end.endOf('week');
      }
      // console.log("Start", (Math.round(start.toDate().getTime() / 1000) - this.state.fetchRange.start) - 24 * 3600);
      // console.log("End", (this.state.fetchRange.end - Math.round(end.toDate().getTime() / 1000)) - 24 * 3600);
      if (Math.round(start.toDate().getTime() / 1000) - this.state.fetchRange.start < (32 * 24 * 3600)) {
        const rangeStart = Math.round(start.toDate().getTime() / 1000) - (90 * 24 * 3600);
        const rangeEnd = rangeStart + (150 * 24 * 3600);
        // console.log("newRange", {start: rangeStart, end: rangeEnd});
        this.updateData({start: rangeStart, end: rangeEnd});
      } else if (this.state.fetchRange.end - Math.round(end.toDate().getTime() / 1000) < (32 * 24 * 3600)) {
        const rangeEnd = Math.round(end.toDate().getTime() / 1000) + (90 * 24 * 3600);
        const rangeStart = rangeEnd - (150 * 24 * 3600);
        // console.log("newRange", {start: rangeStart, end: rangeEnd});
        this.updateData({start: rangeStart, end: rangeEnd});
      }
    });
  }


  updateData(fetchRange = {}) {
    if (Object.keys(fetchRange).length === 0) {
      fetchRange = this.state.fetchRange;
    }
    var self = this;
    const getIt = () => {
      getData(`calendar/feed${this.props['match']['params']['cal_id'] ? "/" + this.props['match']['params']['cal_id'] : "/" + this.state.chosenCalendar}`, fetchRange, this.props.token)
        .then((data) => {
          if (data.status === "Success") {
            self.setState({
              events: data.data.calendar,
              calendarList: data.data.calendarList,
              dataLoaded: true,
              loading: false,
              fetchRange: {
                ...fetchRange
              }
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    }
    // if (!this.state.loading) {
    //   this.setState({loading: true}, () => {
    //     getIt();
    //   });
    // } else {
    getIt();
    // }
  }

  eventStyleGetter(event, start, end, isSelected) {
    if (event.subStatus > 0) {
      const styleIt = getAARStatus(event.subStatus);
      event.eventColor = styleIt.bgColor || event.eventColor;
      event.color = styleIt.color || event.color;
    }
    var style = {
      backgroundColor: event.colorOverride || event.eventColor || "",
      color: event.color || "",
      fontSize: 10,
      zIndex: 100
    };
    return {
      style: style
    };
  }

  addSelection(selection) {
    // console.log({start: selection.start, end: selection.end});
    EventClient.emit("CALENDAR_ENTRY_ADD", {
      addSelection: {start: selection.start, end: selection.end},
      calId: this.state.chosenCalendar,
      lead: this.state.lead,
      followup: this.props.followup
    })
    // this.setState({addSelection: {start: selection.start, end: selection.end}, showAddCalEntry: true})
  }

  render() {
    let self = this;
    const eventStart = function (event) {
      return forceSingleTimeZone(formatTimeFromEpoch(event.starttime));
    };
    const eventEnd = function (event) {
      return forceSingleTimeZone(formatTimeFromEpoch(event.endtime));
    };
    const titleAccessor = function (event) {
      let status = "";
      if (event.aar_status !== 1) {
        status = " (" + event.display + ")";
      }
      return (Number(event.allDay) === 0 ? displayMilHoursMinutesFromTime(eventStart(event)) + " " : "") + event.title + status;
    };
    const agendaTitleAccessor = function (event) {
      return <div style={{cursor: "pointer"}}
                  onClick={() => self.setState({editID: event.id})}>{titleAccessor(event)}</div>;
    };

    const dateFilter = function (events) {
      if (self.state.dateRange.start > 0 && self.state.dateRange.end > 0) {
        return events.filter((event) => event.start >= (self.state.dateRange.start.toDate().getTime() / 1000) && event.start <= (self.state.dateRange.end.toDate().getTime() / 1000));
      } else {
        return [];
      }
    }

    const isScheduling = () => !!this.state.lead && !this.props.followup
    const isFollowup = () => !!this.state.lead && this.props.followup

    return (
      <div className="animated fadeIn">
        <LoadingDialog isOpen={this.state.loading}/>
        {this.state.dataLoaded && (
          <Card>
            <CardHeader style={{display: 'inherit'}}>
              <i className="icon-calendar"></i>
              Calendar
              {this.state.calendarList.length > 1 && (
                <span style={{marginLeft: 10}} className="d-sm-down-none">
                  <Input type="select" value={this.state.chosenCalendar}
                         style={{width: "fit-content", height: 24, fontSize: 12, paddingTop: 0, paddingBottom: 0}}
                         onChange={(evt) => {
                           this.setState({chosenCalendar: evt.target.value});
                           EventClient.emit("NAVIGATE", `/calendar/${evt.target.value}${isScheduling() ? `/schedule/${this.state.lead.id}` : ""}${isFollowup() ? `/followup/${this.state.lead.id}` : ""}`);
                           // this.props.history.push(`/calendar/${evt.target.value}${isScheduling() ? `/schedule/${this.state.lead.id}` : ""}${isFollowup() ? `/followup/${this.state.lead.id}` : ""}`);
                           // if (this.props.hasOwnProperty('onCalendarChange')) {
                           //   this.props.onCalendarChange(evt.target.value);
                           // }
                         }}>
                    <option key={0} value={this.props.loginID}>My Calendar</option>
                    {this.state.calendarList.map((calendar, index) => {
                      if (calendar.cal_id === this.props.loginID) return;
                      return (
                        <option key={index + 1}
                                value={calendar.cal_id}>{`${calendar.agencyDisplay} > ${calendar.userDisplay}`}</option>
                      )
                    })}

                  </Input>
                </span>
              )}
              <div className="card-actions">
                {(isScheduling() || isFollowup()) && (
                  <button onClick={() => this.props.history.push(`/calendar/${this.state.chosenCalendar}`)}>
                    <small className="text-muted">Cancel</small>
                  </button>
                )}
                <button onClick={() => EventClient.emit("CALENDAR_ENTRY_ADD", {
                  calId: this.state.chosenCalendar,
                  lead: this.state.lead,
                  followup: this.props.followup
                })}>
                  <small className="text-muted">Add</small>
                </button>
                <button onClick={() => this.updateData()}>
                  <small className="text-muted">Refresh</small>
                </button>
              </div>

            </CardHeader>
            <CardBody>
              {this.state.calendarList.length > 1 && (
                <span style={{marginLeft: 10}} className="d-md-none">
                  <Input type="select" value={this.state.chosenCalendar}
                         style={{width: "fit-content", height: 24, fontSize: 12, paddingTop: 0, paddingBottom: 0}}
                         onChange={(evt) => {
                           this.setState({chosenCalendar: evt.target.value});
                           EventClient.emit("NAVIGATE", `/calendar/${evt.target.value}${isScheduling() ? `/schedule/${this.state.lead.id}` : ""}${isFollowup() ? `/followup/${this.state.lead.id}` : ""}`);
                         }}>
                    <option key={0} value={this.props.loginID}>My Calendar</option>
                    {this.state.calendarList.map((calendar, index) => {
                      if (calendar.cal_id === this.props.loginID) return;
                      return (
                        <option key={index + 1}
                                value={calendar.cal_id}>{`${calendar.agencyDisplay} > ${calendar.userDisplay}`}</option>
                      )
                    })}

                  </Input>
                </span>
              )}
              {isScheduling() && (
                <div>Scheduling: {trimJoin([this.state.lead.fname, this.state.lead.lname])}</div>
              )}
              {isFollowup() && (
                <div>Scheduling Followup: {trimJoin([this.state.lead.fname, this.state.lead.lname])}</div>
              )}
              <BigCalendar className="calendar-landscape-show"
                           localizer={localizer}
                           views={['month', 'week', 'day']}
                           events={dateFilter(this.state.events)}
                           step={30}
                           popup={true}
                           showAllEvents
                           defaultDate={new Date()}
                           defaultView='month'
                           toolbar={true}
                           selectable={true}
                           eventPropGetter={this.eventStyleGetter}
                           onSelectEvent={(event) => EventClient.emit("CALENDAR_ENTRY_EDIT", {
                             eventId: event.id,
                             calId: this.state.chosenCalendar,
                             lead: this.state.lead,
                             followup: this.props.followup
                           })}
                           rowLimit={20}
                           startAccessor={eventStart}
                           endAccessor={eventEnd}
                           titleAccessor={titleAccessor}
                           tooltipAccessor={titleAccessor}
                           onClick={console.log}
                           onEventResize={console.log}
                           draggableAccessor={event => true}
                           onNavigate={(date) => this.setCurrentDate(date)}
                           onView={(view) => this.setCurrentView(view)}
                           onSelectSlot={(selection) => this.addSelection(selection)}
                           style={{height: '80em'}}
              />
              <BigCalendar className="calendar-portrait-show"
                           localizer={localizer}
                           views={['agenda']}
                           events={dateFilter(this.state.events)}
                           step={30}
                           popup
                           defaultDate={new Date()}
                           defaultView='agenda'
                           toolbar={true}
                           selectable={true}
                           eventPropGetter={this.eventStyleGetter}
                           onSelectEvent={(event) => EventClient.emit("CALENDAR_ENTRY_EDIT", {
                             eventId: event.id,
                             calId: this.state.chosenCalendar,
                             lead: this.state.lead,
                             followup: this.props.followup
                           })}
                           startAccessor={eventStart}
                           endAccessor={eventEnd}
                           titleAccessor={agendaTitleAccessor}
                           tooltipAccessor={agendaTitleAccessor}
                           onClick={console.log}
                           onEventResize={console.log}
                           draggableAccessor={event => true}
                           onNavigate={(date) => this.setCurrentDate(date)}
                           onView={(view) => this.setCurrentView(view)}
                           onSelectSlot={(selection) => this.addSelection(selection)}
                           style={{height: '80em'}}
              />
            </CardBody>
          </Card>
        )}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Calendar/Calendar.js